export default {
  createPlan: 'Create Plan',
  noModelsAvailable: 'No models available. Create the first one, or talk to the administrator.',
  search: 'Search',
  loading: 'Loading...',
  noPlansAvailable: 'No plans available for this model',
  running: 'Running...',
  headerName: 'Name',
  headerBudget: 'Budget',
  headerPredictedKpi: 'Predicted {kpiName}',
  headerPeriod: 'Period',
  headerCreated: 'Created',
  defaultKpiName: 'Sales',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Shared with external users',
  createFromScratch: 'From Scratch',
  createLastYearActualBudget: 'Last Year, Actual Budget (Strategy Check)',
  createLastYearActualBudgetWeekly: 'Last Year, Actual Budget (Strategy Check)',
  createLastYearNoBudget: 'Last Year, No Budget',
  createNextYearBudgetPropagationMonthly: 'Next Year, Actual Budget Propagation (Forward Looking)',
  createNextYearBudgetPropagationWeekly: 'Next Year, Actual Budget Propagation (Forward Looking)',
  createLastYearOnePulseMonthly: 'Last Year, One Pulse marketing investment',
  createLastYearOnePulseWeekly: 'Last Year, One Pulse marketing investment',
  chooseFromScratchDescription: 'Set the period and enter the spend for each channel yourself.',
  chooseActualBudgetTitle: 'Last Year\'s Actual Budget',
  chooseActualBudgetDescription: 'Loads the actual spend per channel of the last 12 months of data.',
  chooseNoBudgetTitle: 'Last Year, No Budget',
  chooseNoBudgetDescription: 'The same last-12-month period with every channel at zero, ready for you to fill in.',
  chooseOnePulseTitle: 'Last Year, One Pulse',
  chooseOnePulseDescription: 'A single burst at each channel\'s saturation level in the first period, then zero, to see its carry-over.',
  chooseNextYearTitle: 'Next Year Budget Propagation',
  chooseNextYearDescription: 'Loads the spend per channel the model propagates for the upcoming year.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagBlank: 'Blank',
  chooseTagCarryOver: 'Carry-over',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Flexible Dates',
  chooseFlexibleTitle: 'Flexible Dates',
  chooseFlexibleDescription: 'Pick any period: it is pre-filled with actual spend where the model has it and with the budget propagation after that.',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Actual spend',
  flexibleSummaryPropagation: 'Budget propagation',
  flexibleSummaryEmpty: 'No data, starts at 0',
  flexibleSummaryTotal: 'Pre-filled budget',
  flexibleMonths: '{count} month | {count} months',
  flexibleWeeks: '{count} week | {count} weeks',
  flexibleHintActual: 'Actual spend is available through {date}.',
  flexibleHintPropagation: 'Budget propagation covers {from} to {to}.',
  channelMismatchTitle: 'The model\'s channels have changed',
  channelMismatchIntro: 'This model\'s media channels no longer match the ones in this plan, likely because the model was updated after the plan was created. If you continue, the plan will use the model\'s current channels.',
  channelMismatchRemoved: 'Channels in the plan that no longer exist in the model (their spend will be discarded):',
  channelMismatchAdded: 'New channels in the model that were not in the plan (they will start at 0):',
  channelMismatchProceedAnyway: 'Continue anyway',
  channelMismatchCancel: 'Cancel'
}
